import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { memo, useContext, useState } from 'react';
import styles from './map.module.css';
import AppContext from '../../contexts/Appcontext';


const Map = memo(({ style = {}, className = '' }) => {

  const [isShowingTooltip, setIsShowingTooltip] = useState(false);
  const { siteInfos: { location, webname } } = useContext(AppContext);

  const position = (location?.split(',').map(code => Number(code.trim())));

  const icon = new L.Icon({
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });

  function copyPositionToClipboard(event) {
    if (!isShowingTooltip) {
      navigator.clipboard.writeText(event.target.textContent);
      setIsShowingTooltip(true);
      setTimeout(() => setIsShowingTooltip(false), 3000);
    }
  }

  return (
    <>
      {position?.length === 2 &&
        <MapContainer className={className} style={style} center={position} zoom={16}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          <Marker position={position} icon={icon}>
            <Popup>
              <p className={styles.title}>{webname}</p>
              <div className={styles.tooltip_wrapper}>
                {isShowingTooltip && <p className={styles.tooltipText}>در کلیپبورد کپی شد</p>}
                <p dir='ltr' onClick={copyPositionToClipboard}>{`${position[0]}, ${position[1]}`}</p>
              </div>
            </Popup>
          </Marker>
        </MapContainer >
      }
    </>
  )
});

export default Map;
